import React from 'react';
import { HouseSimpleIcon, MonitorIcon } from '@fronton/icons-react';
import { Typography } from 'fronton-react';
import { ButtonWithGAClickButton, Section } from 'common/components';
import { fullWidthButton } from 'common/components/button/button-styles';
import { strictBreakpoints } from 'common/styles/breakpoints';
import { KITCHEN_CDN_PATH } from '../../../kitchen-constants';
import {
  signupBlock,
  signupBlockBody,
  signupBlockIconWrapper,
  signupBlockImage,
  signupBlockImageWrapper,
  signupBlockTitle,
  signupBlockVariant,
  signupBlockVariantItem,
  signupBlockVariantItemTitle,
} from './signup-block-styles';

type TProps = {
  elementBlock: string;
  signUpHref: string;
}

export const SignupBlock: React.FC<TProps> = ({ elementBlock, signUpHref }) => (
  <Section>
    <div className={signupBlock}>
      <div className={signupBlockBody}>
        <Typography className={signupBlockTitle} variant="h2" size="extra">
          Выбирайте там,{'\n'}где вам удобно
        </Typography>
        <div className={signupBlockVariant}>
          <div className={signupBlockVariantItem}>
            <div className={signupBlockIconWrapper}>
              <HouseSimpleIcon type='outline' size='l' color='text-primary' />
            </div>
            <div>
              <Typography className={signupBlockVariantItemTitle} variant="h3">В магазинах Лемана ПРО</Typography>
              <Typography variant="l" size="body_long">
                Посмотреть кухни можно вживую — запишитесь заранее, чтобы мы вас встретили и всё показали
              </Typography>
            </div>
          </div>
          <div className={signupBlockVariantItem}>
            <div className={signupBlockIconWrapper}>
              <MonitorIcon type='outline' size='l' color='text-primary' />
            </div>
            <div>
              <Typography className={signupBlockVariantItemTitle} variant="h3">Онлайн-консультация</Typography>
              <Typography variant="l" size="body_long">
                Создать или завершить проект с дизайнером можно онлайн. Общайтесь в мессенджере или в зуме
              </Typography>
            </div>
          </div>
        </div>
        <ButtonWithGAClickButton
          className={fullWidthButton}
          elementBlock={elementBlock}
          elementName="Выбирайте там, где вам удобно"
          elementText="Записаться"
          href={signUpHref}
          title="Записаться на консультацию"
          fullWidth
          variant="accent"
        >
          Записаться
        </ButtonWithGAClickButton>
      </div>
      <div className={signupBlockImageWrapper}>
        <picture>
          <source srcSet={`${KITCHEN_CDN_PATH}/signup-block/1-ld.jpg/1.jpg`} media={strictBreakpoints['--only-largeDesktop']} />
          <source srcSet={`${KITCHEN_CDN_PATH}/signup-block/1-d.jpg/1.jpg`} media={strictBreakpoints['--only-desktop']} />
          <source srcSet={`${KITCHEN_CDN_PATH}/signup-block/1-t.jpg/1.jpg`} media={strictBreakpoints['--only-tablet']} />
          <img
            alt="Изображение консультанта"
            className={signupBlockImage}
            src={`${KITCHEN_CDN_PATH}/signup-block/1-m.jpg/1.jpg`}
          />
        </picture>
      </div>
    </div>
  </Section>
);
